export type GetDipByRegionListResponse = {
  /**
   * The results of this get_dip_by_region_list response body.
   */
  dipByRgnList: DipByRgn[];
};

type DipByRgn = {
  dipByRgn: string;
  rgnIdntfrTypeCd: string;
};
